import React, { Component } from 'react';

class Aboutme extends Component {
    state = {  }
    render() { 
        return ( 
            <div className='main-page'>
                <h1>Aboutme page</h1>
            </div>
         );
    }
};
 
export default Aboutme;


// WEBPACK FOOTER //
// ./src/components/Aboutme.js